export const LOGIN_DOMAIN_Dev= "https://swarnandhra.dev.nidhi.apcfss.in/";
export const LOGIN_DOMAIN_Test= "https://swarnandhra.test.nidhi.apcfss.in/";
export const LOGIN_DOMAIN_Live= "https://swarnaandhra.apcfss.in/";
export const live_url = "https://api.swarnaandhra.apcfss.in/swarnaandhra/";
 export const dev_url = "https://egovapi.dev.nidhi.apcfss.in/swarnandhra/";
 export const test_url = "https://egovapi.test.nidhi.apcfss.in/swarnandhra/";
 
// export const dev_url = "http://172.16.119.67:8080/swarnandhra/";  

 export const dev_loginuploadtoken_url = "https://egovapi.dev.nidhi.apcfss.in/swarnandhra/fileUpload";
 export const housing_uploadtoken_dev = "https://housingapi.dev.nidhi.apcfss.in/yjcapi/YJCAPI/userlogin";
 export const housing_uploadtoken_live = "https://api.aphousing.apcfss.in/yjcapi/YJCAPI/userlogin";
  
 export const live_loginuploadtoken_url = "https://api.swarnaandhra.apcfss.in/swarnaandhra/fileUpload";

export const fileUpload_url_dev =
  "https://housingapi.dev.nidhi.apcfss.in/dmsHousing/user-defined-path/file-upload/Housing/";
export const downloadUrl_dev =
  "https://housingapi.dev.nidhi.apcfss.in/dmsHousing/file/download?folder=Housing/";
export const fileUpload_url_live =
  "https://api.aphousing.apcfss.in/dmsHousing/user-defined-path/file-upload/Housing/";
export const downloadUrl_live =
  "https://api.aphousing.apcfss.in/dmsHousing/file/download?folder=Housing/";


  
 export const LOGIN_DOMAIN =LOGIN_DOMAIN_Dev;
 export const final_url = dev_url;

 const Mer_url_dev = "https://planningmerreports.dev.nidhi.apcfss.in/";
const Mer_url_live = "https://plgmer.swarnaandhra.apcfss.in/";


 const downloadfileurl_dev = "https://housingapi.dev.nidhi.apcfss.in/yjcapi/YJCAPI/userlogin";
const downloadfileurl_live = "https://api.aphousing.apcfss.in/yjcapi/YJCAPI/userlogin";

export const downloadfileurl = downloadfileurl_dev; 
export const Mer_dashboard_url = Mer_url_dev; 
export const upload_url = fileUpload_url_dev;
export const downloadUrl = downloadUrl_dev;
export const Uploadtokenurl = dev_loginuploadtoken_url;
export const housingtokenurl = housing_uploadtoken_dev;









